import React from "react";
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';

export default function DHIconMinus({fontSize, style}) {

    return <RemoveCircleOutlineOutlinedIcon sx={{ fontSize: fontSize }} style={{...style}}/>
}